import { Delete, Edit } from '@mui/icons-material';
import { Box, IconButton, TableBody, TableHead, TableRow, useMediaQuery } from '@mui/material';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import BSTableContainer from './components/BSTableContainer';
import BSTableHeaderCell from './components/BSTableHeaderCell';
import BSTableBodyCell from './components/BSTableBodyCell';
import BSTable from './components/BSTable';

const EventsTable = ({ events, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <BSTableContainer>
      <BSTable>
        <TableHead>
          <TableRow sx={{ backgroundColor: (theme) => theme.palette.background.paper }}>
            <BSTableHeaderCell>Event Name</BSTableHeaderCell>
            <BSTableHeaderCell
              hidden={isMobile}
              sx={{
                color: 'primary.contrastText',
                fontWeight: 'bold',
                fontSize: 18,
                borderBottom: 'none'
              }}>
              Format
            </BSTableHeaderCell>
            <BSTableHeaderCell
              hidden={isMobile}
              sx={{
                color: 'primary.contrastText',
                fontWeight: 'bold',
                fontSize: 18,
                borderBottom: 'none'
              }}>
              Venue
            </BSTableHeaderCell>
            <BSTableHeaderCell
              align="right"
              sx={{
                color: 'primary.contrastText',
                fontWeight: 'bold',
                fontSize: 18,
                borderBottom: 'none'
              }}>
              Start Date
            </BSTableHeaderCell>
            <BSTableHeaderCell
              hidden={isMobile}
              align="right"
              sx={{
                color: 'primary.contrastText',
                fontWeight: 'bold',
                fontSize: 18,
                borderBottom: 'none'
              }}>
              End Date
            </BSTableHeaderCell>
            <BSTableHeaderCell
              align="right"
              sx={{
                color: 'primary.contrastText',
                fontWeight: 'bold',
                fontSize: 18,
                borderBottom: 'none'
              }}>
              Actions
            </BSTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {events.map((event, idx) => (
            <TableRow
              key={event.id}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                backgroundColor: (theme) => theme.palette.background.paper
              }}>
              <BSTableBodyCell
                sx={{
                  fontWeight: 500,
                  color: 'primary.contrastText',
                  borderBottom: 'none',
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
                onClick={() => navigate(`/events/${event.id}`)}>
                {event.name}
              </BSTableBodyCell>

              <BSTableBodyCell hidden={isMobile}>
                {event.gameFormat ? event.gameFormat.name : 'N/A'}
              </BSTableBodyCell>
              <BSTableBodyCell hidden={isMobile}>
                {event.venue ? event.venue.name : 'N/A'}
              </BSTableBodyCell>

              <BSTableBodyCell>{moment(event.startDate).format('MMM D, YYYY')}</BSTableBodyCell>

              <BSTableBodyCell hidden={isMobile} align="right">
                {moment(event.endDate).format('MMM D, YYYY')}
              </BSTableBodyCell>

              <BSTableBodyCell align="right">
                <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'}>
                  <IconButton onClick={() => onEdit(event)} color="primary">
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => onDelete(event)} color="error">
                    <Delete />
                  </IconButton>
                </Box>
              </BSTableBodyCell>
            </TableRow>
          ))}
        </TableBody>
      </BSTable>
    </BSTableContainer>
  );
};

export default EventsTable;
